import { Route } from "wouter";
import GADashboard from "@/pages/ga/GADashboard";
import GABrokerAccounts from "@/pages/ga/GABrokerAccounts";
import GABrokerDetail from "@/pages/ga/GABrokerDetail";
import GAClientView from "@/pages/ga/GAClientView";
import GALicensePool from "@/pages/ga/GALicensePool";
import GAApiConnections from "@/pages/ga/GAApiConnections";
import GAUsers from "@/pages/ga/GAUsers";
import GAAuditLog from "@/pages/ga/GAAuditLog";
import GASettings from "@/pages/ga/GASettings";
import GADocuments from "@/pages/ga/GADocuments";
import GASubmissions from "@/pages/ga/GASubmissions";
import GACarrierSettings from "@/pages/ga/GACarrierSettings";
import GAServiceRequests from "@/pages/ga/GAServiceRequests";
import GARenewalCalendar from "@/pages/ga/GARenewalCalendar";

export const GADashboardComponent = GADashboard;

export function GARoutes() {
  return (
    <>
      <Route path="/ga/dashboard" component={GADashboard} />
      <Route path="/ga/brokers" component={GABrokerAccounts} />
      <Route path="/ga/brokers/:brokerAccountId" component={GABrokerDetail} />
      <Route path="/ga/brokers/:brokerAccountId/clients/:clientId" component={GAClientView} />
      <Route path="/ga/license-pool" component={GALicensePool} />
      <Route path="/ga/api-connections" component={GAApiConnections} />
      <Route path="/ga/users" component={GAUsers} />
      <Route path="/ga/audit-log" component={GAAuditLog} />
      <Route path="/ga/settings" component={GASettings} />
      <Route path="/ga/documents" component={GADocuments} />
      <Route path="/ga/submissions" component={GASubmissions} />
      <Route path="/ga/carrier-settings" component={GACarrierSettings} />
      <Route path="/ga/service-requests" component={GAServiceRequests} />
      <Route path="/ga/renewal-calendar" component={GARenewalCalendar} />
      {/* /settings → AccountSettings omitted: that page lives only on
          feature/admin-portal. GA users use /ga/settings instead. */}
    </>
  );
}
